import { css } from "@emotion/react";

export const categoryButtonStyles = css`
  text-transform: capitalize;
`;
